// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__PhnUH","range":"MonthRangeSwitch_range__2wquN","disabled":"MonthRangeSwitch_disabled__3SFnC"};